import { FC } from 'react'
import Swal from 'sweetalert2'

import {
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { EnderecoDtoUpdate, EnderecoList } from '../../../../empresa/empresas-list/core/_models'
import { EnderecoModal } from '../../components/modal/EnderecoModal'
import { OrigemEndereco, updateEnderecoDaOrigem } from '../../core/_origem'
import { useQueryResponse } from '../../core/QueryResponseProvider'

type Props = {
  origem: OrigemEndereco
  idOrigem: number
  endereco: EnderecoList
}

export const EnderecosActionsCell: FC<Props> = ({ origem, idOrigem, endereco }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()

  const isAtivo = endereco.ativo ?? true
  const nome = endereco.nome || endereco.tipoEndereco || 'Endereço'

  const openEditModal = () =>
    showModal({
      title: 'Alterar endereço',
      size: ModalSize.Large,
      content: <EnderecoModal origem={origem} idOrigem={idOrigem} endereco={endereco} />,
    })

  // Não existe endpoint de exclusão de endereço: inativar é a forma de tirá-lo de circulação
  // sem perder o histórico dos atendimentos que já o referenciam.
  const setStatus = async (ativo: boolean) => {
    try {
      showAlertLoading()
      const dados: EnderecoDtoUpdate = {
        id: endereco.id,
        cep: endereco.cep as string,
        logradouro: endereco.logradouro as string,
        numero: endereco.numero as string,
        complemento: endereco.complemento || null,
        bairro: endereco.bairro as string,
        cidade: endereco.cidade as string,
        uf: (endereco.uf ?? endereco.UF) as string,
        ativo,
      }
      await updateEnderecoDaOrigem(origem, idOrigem, dados)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi ${ativo ? 'ativado' : 'inativado'}.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  // Inativar pede confirmação; ativar é reversível e não pede.
  const askInativar = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Inativar endereço?',
      text: `${nome} ficará inativo. Você pode reativá-lo quando quiser.`,
      confirmButtonText: 'Inativar',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (confirmed) await setStatus(false)
  }

  return (
    <RowActions
      itemName={`endereço ${nome}`}
      primaryAction={{ label: 'Editar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[
        isAtivo
          ? { label: 'Inativar', onClick: askInativar }
          : { label: 'Ativar', onClick: () => setStatus(true) },
      ]}
    />
  )
}
